export default __webpack_public_path__ + "static/jobs-8c66d3755c7ff9383c75b52eb6148748.jpg";